import React from 'react'
import { Link } from "react-router-dom";

import imagen301 from '../../../Img/301/E01/P01/bg.png';
import imagen302 from '../../../Img/302/E01/P01/bg.png';
import imagen304 from '../../../Img/304/E01/P01/bg.png';
import imagen307P01 from '../../../Img/307/E01/P01/bg.png';
import imagen307P02 from '../../../Img/307/E02/P02/bg.png';
import imagen307P03 from '../../../Img/307/E01/P03/bg.png';
import { useState } from 'react';

export const PaginaExterna = (props) => {
    const { children, Titulo, CodigoCompania, CodigoEmpresa = "E01", CodigoPlanta = "P01" } = props;
    const [selectedOption, setSelectedOption] = useState('/CSS/dx.light.css');

    React.useEffect(() => {
        if (!selectedOption) return;

        const existing = document.getElementById('theme-link');
        if (existing) {
            existing.href = selectedOption;
            return;
        }

        const link = document.createElement('link');
        link.id = 'theme-link';
        link.rel = 'stylesheet';
        link.href = selectedOption;
        document.head.appendChild(link);

        return () => {
            const el = document.getElementById('theme-link');
            if (el) document.head.removeChild(el);
        };
    }, []);

    React.useEffect(() => {
        if (!selectedOption) return;

        const existing = document.getElementById('theme-link');
        if (existing) {
            existing.href = selectedOption;
            return;
        }

        const link = document.createElement('link');
        link.id = 'theme-link';
        link.rel = 'stylesheet';
        link.href = selectedOption;
        document.head.appendChild(link);

        return () => {
            const el = document.getElementById('theme-link');
            if (el) document.head.removeChild(el);
        };
    }, [selectedOption]);

    // Función para seleccionar la imagen basada en CodigoCompania
    const getImage = (codigoCompania) => {
        switch (codigoCompania) {
            case "301":
                return imagen301;
            case "302":
                return imagen302;
            case "304":
                return imagen304;
            case "307":
                switch (CodigoPlanta) {
                    case "P01":
                        return imagen307P01;
                    case "P02":
                        return imagen307P02;
                    case "P03":
                        return imagen307P03;
                    default:
                        return imagen307P01;
                }
            default:
        }
    };

    // Selecciona la imagen adecuada
    const selectedImage = getImage(CodigoCompania);

    return (
        <div>
            <div id="wrapper">
                <div id="content-wrapper" style={{ height: "97vh", flexGrow: 1, overflow: "auto" }}>
                    <div className="container-fluid">
                        <ol>
                            <img src={getImage(CodigoCompania)} alt="Logo" style={{ width: '100%' }} />
                            <br />
                            <br />
                            <br />
                            {Titulo}
                        </ol>
                    </div>
                    <div className="container-fluid" >
                        {/* <!-- React AG-GRID --> */}

                        {/* Contenido escalado con zoom (no afecta scroll) */}
                        <div style={{ margin: "10px", zoom: 0.80 }}>
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}